// extracted by mini-css-extract-plugin
module.exports =  {"attachments-list-wrapper":"tUmJPCg","attachmentsListWrapper":"tUmJPCg","label":"nuyKirn","attachments-list":"QAw_IHf","attachmentsList":"QAw_IHf","item":"IaR65KF"};